import { ThemeProvider } from '@mui/material/styles';
import NavbarStyle from './NavbarStyle';
import { navbarTheme } from '../styles/defaultTheme';
import useNewNavigation from '../../core/hooks/useNewNavigation';

const NavbarWrapperLayout = () => {
  const { hideNavbar } = useNewNavigation();

  // Con la navegación nueva el alumno se mueve por la barra de arriba (y las pestañas en el celular)
  if (hideNavbar) {
    return null;
  }

  return (
    <ThemeProvider theme={navbarTheme}>
      <NavbarStyle />
    </ThemeProvider>
  );
};

export default NavbarWrapperLayout;
